export default {
      id: "other-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#other",
      toString: function () {
        return this.url;
      }
    }